module.exports = __webpack_public_path__ + "img/icon-happy-staff.8b14804b.png";